import React from 'react';
import { MealPlanDisplayShefFragment } from 'src/gqlReactTypings.generated.d';
import { ScrollSnapCarousel } from 'web-common/src/shared/design-system/components/ScrollSnapCarousel';
import { MealPlanShefCard } from './MealPlanShefCard';

export interface MealPlanShefCardCarouselProps {
  shefs: MealPlanDisplayShefFragment[];
  onShefClick?: (shefId: string) => void;
  addLeftMargin?: boolean;
}

const MealPlanShefCardCarousel: React.FC<MealPlanShefCardCarouselProps> = ({
  addLeftMargin = false,
  shefs,
  onShefClick,
}) => (
  <ScrollSnapCarousel addLeftMargin={addLeftMargin} showScrollButtonsOnLargeScreen>
    {shefs.map((shef) => {
      // Extract the data needed for the ShefCard component
      const shefName = shef.publicName ?? 'Shef';
      const shefImageUrl = shef.imageUrl ?? '';
      const cuisines = shef.shefProfile?.cuisineCategories?.map((c) => c.title) ?? [];
      const rating = shef.rating?.score ?? 4.8; // Default rating
      const backgroundImageUrl = shef.shefProfile?.coverPhotoUrl ?? '';
      const totalOrders = shef.rating?.count ?? 0;

      return (
        <MealPlanShefCard
          key={shef.id}
          shefId={shef.id}
          shefName={shefName}
          shefImageUrl={shefImageUrl}
          cuisines={cuisines}
          rating={rating}
          ratingCount={shef.rating?.count ?? 0}
          totalOrders={totalOrders}
          backgroundImageUrl={backgroundImageUrl}
          onClick={onShefClick}
        />
      );
    })}
  </ScrollSnapCarousel>
);

export default MealPlanShefCardCarousel;
